var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createWithEqualityFn } from 'zustand/traditional';
import { listBaseActions } from './base-actions';
export function createListStore(_a) {
    var _b = _a.customActions, customActions = _b === void 0 ? function () { return function () { return ({}); }; } : _b, initialValues = _a.initialValues;
    return createWithEqualityFn(function (set, get, api) {
        var _a;
        return (__assign(__assign(__assign({}, initialValues), listBaseActions(initialValues)(set, get, api)), (_a = customActions === null || customActions === void 0 ? void 0 : customActions(initialValues)) === null || _a === void 0 ? void 0 : _a(set, get, api)));
    });
}
